import { render, staticRenderFns } from "./TeacherNotificationInboxDetail.vue?vue&type=template&id=52741b98"
import script from "./TeacherNotificationInboxDetail.vue?vue&type=script&lang=js"
export * from "./TeacherNotificationInboxDetail.vue?vue&type=script&lang=js"
import style0 from "./TeacherNotificationInboxDetail.vue?vue&type=style&index=0&id=52741b98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports